/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Personal_Favorite_AddedInputs */

const en_us2_exercise_personal_favorite_added = /** @type {(inputs: Exercise_Personal_Favorite_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Added to favourites`)
};

const pt_br2_exercise_personal_favorite_added = /** @type {(inputs: Exercise_Personal_Favorite_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicionado aos favoritos`)
};

const es_419_exercise_personal_favorite_added = /** @type {(inputs: Exercise_Personal_Favorite_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agregado a favoritos`)
};

const pt_pt2_exercise_personal_favorite_added = /** @type {(inputs: Exercise_Personal_Favorite_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicionado aos favoritos`)
};

const fr_fr2_exercise_personal_favorite_added = /** @type {(inputs: Exercise_Personal_Favorite_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouté aux favoris`)
};

const de_de2_exercise_personal_favorite_added = /** @type {(inputs: Exercise_Personal_Favorite_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zu Favoriten hinzugefügt`)
};

const it_it2_exercise_personal_favorite_added = /** @type {(inputs: Exercise_Personal_Favorite_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiunto ai preferiti`)
};

/**
* | output |
* | --- |
* | "Added to favourites" |
*
* @param {Exercise_Personal_Favorite_AddedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_personal_favorite_added = /** @type {((inputs?: Exercise_Personal_Favorite_AddedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Personal_Favorite_AddedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_personal_favorite_added(inputs)
	if (locale === "es-419") return es_419_exercise_personal_favorite_added(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_personal_favorite_added(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_personal_favorite_added(inputs)
	if (locale === "de-DE") return de_de2_exercise_personal_favorite_added(inputs)
	if (locale === "it-IT") return it_it2_exercise_personal_favorite_added(inputs)
	return en_us2_exercise_personal_favorite_added(inputs)
});
export { exercise_personal_favorite_added as "exercise-personal.favorite_added" }